<template>
    <div class="container">
        <img class="mb-4" src="../assets/img/logo.png" alt="Logo" width="200" height="110">
        <div class="row">
            <div class="form-group row">
                <label for="password" class="col-sm-2 col-form-label">Password</label>
                <div class="col-sm-10">
                    <div :class="{ error: v$.password.$errors.length }">
                        <input type="text" class="form-control" id="password" v-model="password">
                        <div class="input-errors" v-for="error of v$.password.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label for="confirmation" class="col-sm-2 col-form-label">Confirmation</label>
                <div class="col-sm-10">
                    <div :class="{ error: v$.password.$errors.length }">
                        <input type="text" class="form-control" id="confirmation" v-model="confirmation">
                        <div class="input-errors" v-for="error of v$.confirmation.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="btn btn-primary" type="button" @click="resetPassword">Reset Password</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import useVuelidate from '@vuelidate/core'
import { required, sameAs, helpers } from '@vuelidate/validators'

export default {
    name: 'ResetPassword',
      setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            password: '',
            confirmation: '',
            token: ''
        }
    },
    validations () {
        return {
            password: { 
                required: helpers.withMessage('Password can not be empty.', required) 
            },
            confirmation: { 
                required: helpers.withMessage('Password Confirmation can not be empty.', required), 
                sameAsPassword: sameAs(this.password)
            },
        }
    }
}
</script>
